<!-- Estilos: src/assets/styles/components/_liga-ui.scss (.lx-*) y _liga-c.scss (.lxc-*). -->
<section class="lx-pagina" lang="es" [class.lx-pagina--con-cta]="!startedProcess">
  <header class="lx-hero">
    <div class="lx-hero__cabeza">
      <span class="lx-hero__icono" [class.lx-hero__icono--verde]="resultado === 'exito'" aria-hidden="true">
        <fa-icon [icon]="resultado === 'exito' ? iconos.verificado : iconos.ine"></fa-icon>
      </span>
      <div class="lx-hero__textos">
        <span class="lx-hero__eyebrow">Tu identidad</span>
        <h2 class="lx-hero__titulo">{{tituloHero}}</h2>
        <p class="lx-hero__subtitulo">{{subtituloHero}}</p>
        <span class="lx-chip" *ngIf="data.comment && !startedProcess" [ngClass]="estados.corrige.chip">
          <fa-icon [icon]="estados.corrige.icono!" aria-hidden="true"></fa-icon>{{estados.corrige.texto}}
        </span>
      </div>
    </div>
    <div class="lx-hero__pie">
      <ol class="lx-etapas" [attr.aria-label]="'Parte ' + pasoActual + ' de 2'">
        <li [class.is-actual]="!startedProcess" [class.is-listo]="startedProcess" [attr.aria-current]="!startedProcess ? 'step' : null">
          <span class="lx-etapas__barra" aria-hidden="true"></span>
          <span class="lx-etapas__texto"><span class="lx-etapas__marca" aria-hidden="true"><fa-icon *ngIf="startedProcess; else parteUno" [icon]="iconos.listo"></fa-icon><ng-template #parteUno>1</ng-template></span>Fotos y selfie</span>
        </li>
        <li [class.is-actual]="startedProcess && resultado !== 'exito'" [class.is-listo]="resultado === 'exito'" [attr.aria-current]="startedProcess && resultado !== 'exito' ? 'step' : null">
          <span class="lx-etapas__barra" aria-hidden="true"></span>
          <span class="lx-etapas__texto"><span class="lx-etapas__marca" aria-hidden="true"><fa-icon *ngIf="resultado === 'exito'; else parteDos" [icon]="iconos.listo"></fa-icon><ng-template #parteDos>2</ng-template></span>Confirma</span>
        </li>
      </ol>
    </div>
  </header>

  <!-- ===== Paso 1 de 2: preparación ===== -->
  <ng-container *ngIf="!startedProcess; else enProceso">
    <div class="lx-alerta lx-alerta--error" *ngIf="data.comment">
      <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="iconos.error"></fa-icon></span>
      <div class="lx-alerta__cuerpo">
        <p class="lx-alerta__titulo">Necesitamos que repitas tu verificación</p>
        <p class="lx-alerta__texto">Motivo: <strong>{{data.comment}}</strong></p>
      </div>
    </div>

    <div class="lx-tarjeta">
      <h3 class="lx-tarjeta__titulo">Así funciona</h3>
      <ol class="lx-lista lx-lista--numerada" style="margin-top: 12px">
        <li>Toca «Empezar verificación»: se abre una ventana segura.</li>
        <li>Toma las fotos de tu INE y tu selfie, como te lo pida.</li>
        <li>Regresa aquí y toca «Ya terminé».</li>
      </ol>
    </div>

    <div class="lx-tarjeta">
      <h3 class="lx-tarjeta__titulo">Para que salga a la primera</h3>
      <ul class="lxc-consejos" style="margin-top: 12px">
        <li class="lxc-consejo" *ngFor="let consejo of consejos">
          <span class="lxc-consejo__icono" aria-hidden="true"><fa-icon [icon]="consejo.icono"></fa-icon></span>
          <span class="lxc-consejo__texto">{{consejo.texto}}</span>
        </li>
      </ul>
    </div>

    <div class="lxc-avisos" aria-live="polite">
      <div class="lx-alerta" *ngFor="let m of responseMessage; trackBy: porMensaje" [ngClass]="tono(m).clase" [attr.role]="tono(m).rol">
        <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="tono(m).icono"></fa-icon></span>
        <div class="lx-alerta__cuerpo">
          <p class="lx-alerta__titulo" *ngIf="m.severity === 'error'">No pudimos preparar tu verificación</p>
          <p class="lx-alerta__texto">{{m.summary}}</p>
          <button type="button" class="lx-btn lx-btn--secundario lx-btn--chico lx-btn--auto lx-alerta__accion"
                  *ngIf="m.severity === 'error'" [disabled]="preparando" (click)="reintentarPreparar()">
            <fa-icon [icon]="iconos.reintentar" aria-hidden="true"></fa-icon><span>Reintentar</span>
          </button>
        </div>
      </div>
    </div>

    <p class="lx-seguro">
      <span class="lx-seguro__icono" aria-hidden="true"><fa-icon [icon]="iconos.seguro"></fa-icon></span>
      <span>Tus fotos se envían de forma segura y solo se usan para confirmar tu identidad.</span>
    </p>
  </ng-container>

  <!-- ===== Paso 2 de 2: confirmar que terminó ===== -->
  <ng-template #enProceso>
    <ng-container *ngIf="revisando; else sinRevisar">
      <div class="lx-vacio lxc-espera" role="status" aria-busy="true">
        <span class="lx-spinner lx-spinner--grande" aria-hidden="true"></span>
        <h3 class="lx-vacio__titulo">Estamos revisando tu verificación</h3>
        <p class="lx-vacio__texto">Toma unos segundos. No cierres esta pantalla.</p>
      </div>
    </ng-container>

    <ng-template #sinRevisar>
      <div class="lx-celebracion" *ngIf="resultado === 'exito'; else porConfirmar">
        <div class="lx-celebracion__check">
          <svg class="lx-check" viewBox="0 0 52 52" aria-hidden="true">
            <circle class="lx-check__circulo" cx="26" cy="26" r="25"></circle>
            <path class="lx-check__trazo" d="M15 27.5l7 7 15-16"></path>
          </svg>
        </div>
        <h3 class="lx-celebracion__titulo">¡Listo! Verificamos tu identidad</h3>
        <p class="lx-celebracion__msg" *ngIf="responseMessage[0]?.summary as msg" role="status">{{msg}}</p>
        <button type="button" class="lx-btn lx-btn--primario" (click)="terminar()"><span>Continuar</span></button>
        <p class="lx-celebracion__nota">Te regresamos a tus pasos en unos segundos.</p>
      </div>

      <ng-template #porConfirmar>
        <div class="lx-tarjeta lx-tarjeta--elevada">
          <div class="lx-halo" aria-hidden="true"><fa-icon [icon]="iconos.ine"></fa-icon></div>
          <h3 class="lx-tarjeta__titulo" style="margin-top: 16px; text-align: center">Termina en la ventana de verificación</h3>
          <p class="lx-tarjeta__subtitulo" style="text-align: center">Cuando acabes las fotos de tu INE y tu selfie, regresa a esta pantalla y confírmalo.</p>

          <div class="lxc-avisos" aria-live="polite" style="margin-top: 14px">
            <div class="lx-alerta" *ngFor="let m of responseMessage; trackBy: porMensaje" [ngClass]="tono(m).clase" [attr.role]="tono(m).rol">
              <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="tono(m).icono"></fa-icon></span>
              <div class="lx-alerta__cuerpo">
                <p class="lx-alerta__titulo" *ngIf="m.severity === 'error'">Aún no vemos tu verificación</p>
                <p class="lx-alerta__texto">{{m.summary}}</p>
              </div>
            </div>
          </div>

          <div class="lx-cta" style="margin-top: 16px">
            <button type="button" class="lx-btn lx-btn--primario" (click)="!revisando && validateUserIdentity()" [disabled]="abriendo">
              <fa-icon [icon]="iconos.verificado" aria-hidden="true"></fa-icon><span>Ya terminé mi verificación</span>
            </button>
            <button type="button" class="lx-btn lx-btn--texto" style="align-self: center" (click)="start()"
                    [disabled]="abriendo || !startButtonIsAvailable" [class.is-cargando]="abriendo">
              <span class="lx-spinner" *ngIf="abriendo" aria-hidden="true"></span>
              <fa-icon *ngIf="!abriendo" [icon]="iconos.abrir" aria-hidden="true"></fa-icon>
              <span>{{abriendo ? 'Abriendo la verificación…' : '¿No se abrió? Abrirla de nuevo'}}</span>
            </button>
          </div>
        </div>
      </ng-template>
    </ng-template>
  </ng-template>
</section>

<!-- CTA fijo (hermano de la página: ningún ancestro con animación ni transform) -->
<div class="lx-cta-fijo" *ngIf="!startedProcess">
  <button type="button" class="lx-btn lx-btn--primario" (click)="startButtonIsAvailable && !abriendo && start()"
          [disabled]="!startButtonIsAvailable && !preparando"
          [class.is-cargando]="preparando || abriendo" [attr.aria-busy]="preparando || abriendo ? 'true' : null">
    <span class="lx-spinner" *ngIf="preparando || abriendo" aria-hidden="true"></span>
    <fa-icon *ngIf="!preparando && !abriendo" [icon]="iconos.ine" aria-hidden="true"></fa-icon>
    <span>{{textoEmpezar}}</span>
  </button>
  <p class="lx-cta-fijo__nota"><fa-icon [icon]="iconos.abrir" aria-hidden="true"></fa-icon>Se abre en una ventana nueva. Ten tu INE a la mano.</p>
</div>
